import { Tooltip } from "@material-tailwind/react";
import { useNavigate } from "react-router";
import { useTomraDrops } from "../../../store/useTomraDrops";

export const UsersTable = () => {
  /** Hooks */
  const navigate = useNavigate();
  const { usersWithBarcodeDrops } = useTomraDrops();

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-3"
            >
              Profile image
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-3">
              Full name
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-3"
            >
              Postalcode
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-3"
            >
              Platform
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-3">
              Total Pay-ou
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-3"
            >
              Drops volume
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-3 text-right">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {usersWithBarcodeDrops?.map((user) => (
            <tr
              key={user?._id}
              className={`${user?.pending_delete ? "bg-red-200" : "bg-white"} ${
                user?.pending_delete ? "hover:bg-red-300" : "hover:bg-gray-100"
              } cursor-pointer transition ease-linear border-b`}
            >
              <th
                onClick={() => navigate(`/edit-user/${user?._id}`)}
                scope="row"
                className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-3 font-bold text-primary-base whitespace-nowrap"
              >
                <img
                  alt="profile-pic"
                  className="w-[40px] h-[40p] mr-3 rounded-full cursor-pointer"
                  src={
                    user?.profileImage ??
                    require("../../../assets/pictures/dummy/dummy-avatar.png")
                  }
                />
              </th>
              <th
                onClick={() => navigate(`/edit-user/${user?._id}`)}
                scope="row"
                className="px-2 sm:px-6 py-1 sm:py-3 font-bold text-primary-base whitespace-nowrap"
              >
                {user?.first_name} {user?.last_name}{" "}
                <p className="text-red-900">
                  {user?.pending_delete && "(Pending delete)"}
                </p>
              </th>
              <td
                onClick={() => navigate(`/edit-user/${user?._id}`)}
                className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-3"
              >
                {user?.postal_code}
              </td>
              <td
                onClick={() => navigate(`/edit-user/${user?._id}`)}
                className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-3"
              >
                {user?.platform === "ios" && (
                  <img
                    className="w-[30px] h-[30px]"
                    alt="ios-logo"
                    src={require("../../../assets/icons/platforms/apple.png")}
                  />
                )}
                {user?.platform === "android" && (
                  <img
                    className="w-[30px] h-[30px]"
                    alt="android-logo"
                    src={require("../../../assets/icons/platforms/android.png")}
                  />
                )}
              </td>
              <td
                onClick={() => navigate(`/edit-user/${user?._id}`)}
                className="px-2 sm:px-6 py-1 sm:py-3"
              >
                {Number(
                  user?.totalRevenue ? user?.totalRevenue / 100 : 0
                )?.toFixed(2)}
                €
              </td>
              <td
                onClick={() => navigate(`/edit-user/${user?._id}`)}
                className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-3"
              >
                {Number(user?.dropsVolume ?? 0) +
                  Number(user?.beevisionDropsVolume ?? 0) +
                  Number(user?.tomraDropsVolume ?? 0)}
              </td>
              <td className="px-2 sm:px-6 py-1 sm:py-3 flex items-center justify-end cursor-pointer">
                <Tooltip content="View profile">
                  <div
                    className="font-satoshi font-medium text-base nowhitespace-nowrap text-primary-base cursor-pointer"
                    onClick={() => navigate(`/edit-user/${user?._id}`)}
                  >
                    View profile
                  </div>
                </Tooltip>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
